import React, { useState } from 'react';

import './styles.css';

import loadTextTest from '../../../../functions/loadTextTest';
import convertAge from '../../../../functions/convertAge';

import UserPhoto from '../../../../components/UserPhoto';
import { Link, useHistory } from 'react-router-dom';
import { FaAngleDown, FaAngleUp, FaPen, FaTrash } from 'react-icons/fa';
import studentsServices from '../../../../services/academy/studentsServices';

export default function StudentProfileCard(props) {
    const [showMore, setShowMore] = useState(false);
    const history = useHistory();

    let name;
    let parentName;
    if (props.studentInfos && props.studentInfos.nome && props.studentInfos.sobrenome)
        name = `${props.studentInfos.nome} ${props.studentInfos.sobrenome}`;
    else
        name = null;

    if (props.studentInfos && props.studentInfos.nome_responsavel && props.studentInfos.sobrenome_responsavel)
        parentName = `${props.studentInfos.nome_responsavel} ${props.studentInfos.sobrenome_responsavel}`;
    else
        parentName = null;

    async function activateStudent() {
        // eslint-disable-next-line no-restricted-globals
        if(confirm("Para editar este aluno, é preciso ativá-lo primeiro. Deseja fazer isso?")) {
            const response = await studentsServices.activateStudent(props.studentInfos.id)
            if(response.status === 200) {
                history.push(`/academia/alunos/${props.studentInfos.id}/editar`);
            }
            else {
                alert("Erro ao ativar o aluno!");
            }
        }
    }

    async function deleteStudent(id, nome) {
        // eslint-disable-next-line no-restricted-globals
        if (confirm(`Deseja excluir o aluno ${nome} permanentemente?`)) {
            const response = await studentsServices.deleteStudent(id);
            if (response.status === 204) {
                history.goBack();
                console.log(`Aluno ${nome} excluido!`);
            } else
                alert("Erro ao excluir aluno, tente novamente!");
        }
    }


    return (
        <div className='student-page-card' id='card-profile'>
            <UserPhoto src={props.studentInfos && props.studentInfos.foto ? props.studentInfos.foto : null}/>
            <div className='student-card-profile-options'>
                <div className='student-card-profile-infos'>
                    <div>
                        <h4><b>{loadTextTest(name)}</b></h4>
                        {
                            props.studentInfos.user ?
                            <span><p className={props.studentInfos.user.ativo ? "active" : "inactive"}>{props.studentInfos.user.ativo ? "Ativo" : "Inativo"}</p></span>
                            :
                            null
                        }
                    </div>
                    <p><b>ID: </b>{props.studentInfos.id}</p>
                    <p><b>Idade: </b>{loadTextTest(convertAge(props.studentInfos.data_nascimento))}</p>
                    {
                        showMore ?
                            <>
                                {parentName ? <p><b>Responsável: </b>{loadTextTest(parentName)}</p> : []}
                                {props.studentInfos.genero ? <p><b>Gênero: </b>{props.studentInfos.genero}</p> : []}
                                {props.studentInfos.user && props.studentInfos.user.email ? <p><b>Email: </b>{props.studentInfos.user.email}</p> : []}
                                {props.studentInfos.telefone ? <p><b>Telefone: </b>{props.studentInfos.telefone}</p> : []}
                                {props.studentInfos.cidade ? <p><b>Cidade: </b>{props.studentInfos.cidade}</p> : []}
                                {props.studentInfos.estado ? <p><b>Estado: </b>{props.studentInfos.estado}</p> : []}
                                {props.studentInfos.bairro ? <p><b>Bairro: </b>{props.studentInfos.bairro}</p> : []}
                                {props.studentInfos.logradouro ? <p><b>Endereço: </b>{props.studentInfos.logradouro}</p> : []}
                            </>
                            : []
                    }
                    <button onClick={() => setShowMore(!showMore)}>
                        {showMore ? "Menos informações" : "Mais informações"} {showMore ? <FaAngleUp /> : <FaAngleDown />}
                    </button>
                </div>

                <div className='student-card-profile-buttons'>
                    {
                        props.studentProfileMode || props.coachMode ?
                            [] :
                            (props.studentInfos.user && props.studentInfos.user.ativo ?
                                <Link className='button' to={props.isAdmin ? `/admin/academias/${props.academyId}/alunos/${props.studentInfos.id}/editar` : `/academia/alunos/${props.studentInfos.id}/editar`}>Editar<FaPen /></Link>
                                :
                                <button className='button' onClick={activateStudent}>Editar<FaPen /></button>
                            )

                    }
                    {
                        props.studentProfileMode || props.coachMode ?
                            null
                            :
                            <button className='button student-card-delete' onClick={() => deleteStudent(props.studentInfos.id, props.studentInfos.nome)}>Excluir <FaTrash/></button>
                    }
                </div>


            </div>
        </div>
    )
}